import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import analytics from '../../../services/analytics';
import subscriptionDataByListKey from './subscription-data';
import Button from '../../common/button/button';
import * as Encryption from '../../common/encryption/encryption';

import './site-subscription.css';

const formContainerStyle = {
  clear: 'left', 
  font: '14px Helvetica,Arial,sans-serif'
};

class SiteSubscription extends Component {
  constructor(props) {
    super(props);

    const { mailingListKey, tags, } = this.props;    

    this.state = {
      mailingListKey: this.getFinalMailingListKey(mailingListKey, tags),
    };
  }

  onSubmit = () => {
    const e = Encryption.encrypt(this.state.email);
    const k = Encryption.encrypt(this.state.mailingListKey);
    localStorage.setItem('es', JSON.stringify({ e, k }))

    analytics.trackMailingListSubscribing(this.props.source, e, this.state.mailingListKey);
  }

  getFinalMailingListKey(mailingListKey, tags) {
    if (mailingListKey) {
      // if (subscriptionDataByListKey[mailingListKey]) return mailingListKey;
      return mailingListKey;
    } 

    if (tags) {
      const relevantTag = tags.find(tag => subscriptionDataByListKey[tag]);
      if (relevantTag) return relevantTag;
    }

    return '';
  }

  onEmailChange = (e) => {
    this.setState({ email: e.target.value });
  }

  render() {
    const { isInline, isBottomTextShown, } = this.props;
    const { mailingListKey } = this.state;
    
    if (!subscriptionDataByListKey[mailingListKey]) return <div></div>;
    const { action, title, additionalTitle, emailInputName } = subscriptionDataByListKey[mailingListKey];

    return (
      <div className={ `site-subscription ${ isInline ? 'inline' : 'box' }` }>
        <div id="mc_embed_signup" style={ formContainerStyle }>
          <form action={ action }
                className="validate" 
                id="mc-embedded-subscribe-form" 
                method="post" 
                name="mc-embedded-subscribe-form" 
                noValidate="" 
                onSubmit={this.onSubmit}
                target="_blank">

            <div id="mc_embed_signup_scroll">
              {
                !isInline && <header>
                  <div className='subscription-title' dangerouslySetInnerHTML={{ __html: this.props.text || title }} />
                  { additionalTitle && <div className='subscription-additional-title' dangerouslySetInnerHTML={{ __html: additionalTitle }} /> }
                </header>
              }

              <div className="mc-field-group">
                <input onChange={ this.onEmailChange } className="required email" id="mce-EMAIL" name="EMAIL" type="email" placeholder="Email" />
                <div className="clear submit-button-container">
                  <Button 
                    id="mc-embedded-subscribe"
                    isDark={ true } 
                    name="subscribe" 
                    type="submit"
                    label="Subscribe" />              
                </div>              
              </div>

              <div aria-hidden="true" style={{position: 'absolute', left: '-5000px'}}>
                <input name={ emailInputName } tabIndex="-1" type="text" />
              </div>

              {
                isBottomTextShown && <div className='newsletter-subscription-bottom-text'>
                  Once a week. No spam. <Link to={ `/newsletters/ag/${ mailingListKey }/subscription` } title='Learn more'>Learn more</Link>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    );
  }
}

SiteSubscription.propTypes = {
  source: PropTypes.string.isRequired,
  sourceValue: PropTypes.number,
  text: PropTypes.string,
  mailingListKey: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
};

SiteSubscription.defaultProps = {
  isInline: false,
  isBottomTextShown: true,
};

export default SiteSubscription;